
import Vue from 'vue';
import {
	MyBalanceMixin,
	TeamUserMixin,
} from '@/mixins';
import RunnitAccountSelectionDialog from '@/views/Runnits/RunnitAccountSelection/RunnitAccountSelectionDialog.vue';
import RunnitTokens from '@/views/Runnits/RunnitTokens.vue';

/**
 * Sidebar account card (design handoff section A): account picker row + the account's token row.
 * The ring fills with usage against the current cycle allotment (empty ring = fresh cycle, full =
 * spent out), clamped at 100%; the number carries any excess.
 */
export default Vue.extend({
	name: 'RunnitSideNavAccountCard',
	mixins: [
		TeamUserMixin,
		MyBalanceMixin,
	],
	props: {
		menuId: { type: String, default: 'sidenav-menu' },
	},
	computed: {
		accountName (): string {
			if (this.onPersonalPlan) return 'Personal';
			return this._get(this.team, 'name') || 'Team';
		},
		accountInitial (): string {
			return (this.accountName || 'P').charAt(0).toUpperCase();
		},
		showTokenRow (): boolean {
			if (this.onPersonalPlan) return true;
			return !!(this.hasShowTokenBalancePermission || this.hasManageCompanyPermission);
		},
	},
	components: {
		RunnitAccountSelectionDialog,
		RunnitTokens,
	},
});
